import React, { useState, useEffect, useContext } from 'react';
import { closeCircle } from 'ionicons/icons';
import { faCalendar, faCircleArrowLeft, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IonModal, IonHeader, IonToolbar, IonButtons, IonButton, IonContent, IonIcon } from '@ionic/react';
import '../../styles/profile/RewardsDisplay.scss';
import baseball from '../../assets/baseball_star.png';
import gift from '../../assets/gift.png';
import glove from '../../assets/glove_star.png';
import pizza from '../../assets/pizza_star.png';
import { getDetailedRewardsHistory } from '../../global/request/user';
import useProfile from '../../global/useProfile';
import { AuthContext } from '../authentication/AuthContext';
import FeedTabs from '../home/FeedTabs';

function Rewards() {
  const authCtx = useContext(AuthContext);
  const [, profileData] = useProfile();
  const [showRewardsModal, setShowRewardsModal] = useState(false);
  const [rewardsTab, setRewardsTab] = useState(0);
  const [rewardsHistory, setRewardsHistory] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateRange, setDateRange] = useState({ lower: new Date(), upper: new Date() });

  const tabsInfo = [
    // { id: 'rewards', label: 'Rewards' },
    { id: 'earn', label: 'How to Earn' },
    { id: 'history', label: 'History' },
  ];

  const incrementSelectedDateMonth = increment => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + increment);
    setSelectedDate(newDate);
  };

  const sameMonth = (date1, date2) =>
    date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();

  useEffect(() => {
    const fetchRewardsHistory = async () => {
      try {
        const token = authCtx.tokens.idToken;
        if (!profileData?.id || !token) return;

        const history = await getDetailedRewardsHistory(token);
        setRewardsHistory(history);
        if (history.length > 0) {
          setDateRange({ lower: history[0].time, upper: new Date() });
        }
      } catch (error) {
        console.error('Failed to fetch rewards history', error);
      }
    };
    fetchRewardsHistory();
  }, [authCtx.tokens.idToken, profileData?.id]);

  const redemptionRatios = [
    { credit: 5, bitecoins: 4000 },
    { credit: 10, bitecoins: 8000 },
    // { credit: 15, bitecoins: 12000 },
  ];

  const earnPointsCategories = [
    {
      title: 'Participate in a FoodFight!',
      image: glove,
      events: [
        { description: 'Win a Foodfight', points: 200 },
        { description: 'Lose a FoodFight', points: 200 },
      ],
    },
    {
      title: 'Refer a Friend, Create a network!',
      image: pizza,
      events: [{ description: 'Invite a friend to complete their first FoodFight', points: 5000 }],
    },
    {
      title: 'New User Strike!',
      image: baseball,
      events: [
        { description: 'Complete your profile with birthdate and favorite sports', points: 500 },
        { description: 'Complete your first FoodFight', points: 500 },
      ],
    },
  ];

  const getEventDetails = event => {
    switch (event.type) {
      case 'first_fight':
        return {
          title: 'First FoodFight',
          image: baseball,
          subtitle: `${event.league} vs @${
            profileData?.username === event.makerUsername ? event.takerUsername : event.makerUsername
          }`,
        };
      case 'won_fight':
        return {
          title: 'Winning FoodFight',
          image: glove,
          subtitle: `${event.league} vs @${
            profileData?.username === event.makerUsername ? event.takerUsername : event.makerUsername
          }`,
        };
      case 'lost_fight':
        return {
          title: 'Losing FoodFight',
          image: glove,
          subtitle: `${event.league} vs @${
            profileData?.username === event.makerUsername ? event.takerUsername : event.makerUsername
          }`,
        };
      case 'tied_fight':
        return {
          title: 'Tying FoodFight',
          image: glove,
          subtitle: `${event.league} vs @${
            profileData?.username === event.makerUsername ? event.takerUsername : event.makerUsername
          }`,
        };
      case 'profile_complete':
        return { title: 'Completing a profile', image: baseball, subtitle: "Let's FoodFight!" };
      case 'referral':
        return { title: 'Referring a friend', image: pizza, subtitle: `Introduced: @${event.refereeUsername}` };
      default:
        return {};
    }
  };
  return (
    <div className='rewards-display'>
      <div className='points-section' role='button' tabIndex={0} onClick={() => setShowRewardsModal(true)}>
        <div className='redeem-button'>Redeem</div>
        <div className='points-text'>
          <span className='points-icon'>⭐</span>
          <span className='points-number'>{profileData?.rewardsPoints}</span>
          Bitecoins
        </div>
        <div className='fight-stat-container'>
          <div className='fight-stat'>
            <p className='type'>Win</p>
            <p className='count'>{profileData?.wins}</p>
          </div>
          <div className='fight-stat'>
            <p className='type'>Loss</p>
            <p className='count'>{profileData?.losses}</p>
          </div>
          <div className='fight-stat'>
            <p className='type'>Tie</p>
            <p className='count'>{profileData?.ties}</p>
          </div>
        </div>
      </div>
      <IonModal
        className='rewards-modal'
        isOpen={showRewardsModal}
        onDidDismiss={() => setShowRewardsModal(false)}
        initialBreakpoint={1}
        breakpoints={[0, 1]}
        backdropDismiss>
        <IonHeader className='ion-no-border'>
          <IonToolbar>
            <div className='title'>FoodFight Rewards</div>
            <IonButtons slot='end' className='close-button'>
              <IonButton onClick={() => setShowRewardsModal(false)}>
                <IonIcon slot='icon-only' icon={closeCircle} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className='navigator-container'>
            <FeedTabs tabs={tabsInfo} activeTabIdx={rewardsTab} setActiveTabIdx={setRewardsTab} />
          </div>
          {tabsInfo[rewardsTab].id === 'rewards' && (
            <div className='rewards-tab'>
              <div className='tab-subsection'>
                <p className='heading'>REDEEM YOUR BITECOINS</p>
                <div className='points-display'>
                  <span className='intro-text'>You have:</span>
                  <div className='points-text'>
                    <span className='points-icon'>⭐</span>
                    <span className='points-number'>{profileData?.rewardsPoints}</span>
                    Bitecoins
                  </div>
                </div>
                {redemptionRatios.map(ratio => (
                  <div className='redeem-option' key={ratio.credit}>
                    <img src={gift} alt='' />
                    <div className='text'>
                      <p className='credit'>${ratio.credit} Credit</p>
                      <p className='bitecoin'>Use {ratio.bitecoins} Bitecoins</p>
                    </div>
                    <button className='redeem' type='submit'>
                      Redeem
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
          {tabsInfo[rewardsTab].id === 'earn' && (
            <div className='earn-tab'>
              <div className='points-system tab-subsection'>
                <p className='heading'>POINTS SYSTEM</p>
                <div className='unit-explanation'>
                  <div className='unit'>
                    <span>BITE</span>
                    <span>COINS</span>
                  </div>
                  <div className='explanation'>
                    Spendable points that convert to real-world credit and decrease after each redemption.
                  </div>
                </div>
              </div>
              <div className='earning-points tab-subsection'>
                <p className='heading'>EARNING POINTS</p>
                {earnPointsCategories.map(category => (
                  <div className='category' key={category.title}>
                    <img src={category.image} alt='' />
                    <div className='info'>
                      <p className='title'>{category.title}</p>
                      <ul className='event-list'>
                        {category.events.map(event => (
                          <li key={event.description}>
                            <div className='event-item'>
                              <div className='description'>{event.description}</div>
                              <div className='points'>⭐+{event.points} BC</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {tabsInfo[rewardsTab].id === 'history' && (
            <div className='history-tab'>
              <div className='date-selector'>
                <button
                  type='submit'
                  onClick={() => incrementSelectedDateMonth(-1)}
                  className='change-date'
                  disabled={sameMonth(selectedDate, dateRange.lower)}>
                  <FontAwesomeIcon icon={faCircleArrowLeft} />
                </button>
                <div className='current-date'>
                  <FontAwesomeIcon className='calendar-icon' icon={faCalendar} />
                  {selectedDate.toLocaleDateString('en-US', { month: 'long' })}
                </div>
                <button
                  type='submit'
                  onClick={() => incrementSelectedDateMonth(1)}
                  className='change-date'
                  disabled={sameMonth(selectedDate, dateRange.upper)}>
                  <FontAwesomeIcon icon={faCircleArrowRight} />
                </button>
              </div>
              <div className='history-display'>
                <p className='heading'>HISTORY</p>
                <div className='total-container'>
                  <div className='total'>
                    <span className='text'>Total Bitecoins</span>
                    <span className='count'>{profileData?.rewardsPoints}</span>
                  </div>
                </div>
                <div className='event-list'>
                  {rewardsHistory
                    .filter(event => sameMonth(event.time, selectedDate))
                    .map(event => {
                      const details = getEventDetails(event);
                      return (
                        <div className='event' key={event.trackerId}>
                          <img src={details.image} alt='' />
                          <div className='text'>
                            <p className='title'>{details.title}</p>
                            <p className='subtitle'>{details.subtitle}</p>
                          </div>
                          <div className='points'>
                            ⭐ {event.rewardsPoints > 0 && '+'}
                            {event.rewardsPoints} BC
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </IonContent>
      </IonModal>
    </div>
  );
}

export default Rewards;
